import CheckDone from 'assets/images/successful-animation.gif';
import ButtonCommon from 'components/common/ButtonCommon';
import { DESKTOP_MIN_WIDTH, TABLET_MAX_WIDTH } from 'constants';
import useLang from 'hooks/useLang';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';

const UpdateProfilePopup = ({
  isOpen,
  buttonLabel2,
  onClick,
  title,
  desc,
  backDropZIndex,
}) => {
  const { t } = useLang();

  return (
    <>
      <style>
        {`
          @media screen and (max-width: ${TABLET_MAX_WIDTH - 1}px) {
            .modal {
              background: transparent;
            }
          }
        `}
        {`
          .edit-profile-successfully-modal-backdrop {
            z-index: ${backDropZIndex || 1055}!important;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `}
      </style>

      <ModalStyled
        show={isOpen}
        onHide={onClick}
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="edit-profile-successfully-modal-backdrop"
        centered
      >
        <ModalBody>
          <CheckDoneImage src={CheckDone} alt="" />
          <Text>{title}</Text>
          <SubText>{desc}</SubText>
        </ModalBody>
        <ModalFooter>
          <ButtonCommon
            value={buttonLabel2 || t('button_ok')}
            styles={{
              width: '180px',
              marginInline: 'auto',
            }}
            color="var(--c-primary)"
            background="var(--bg-primary)"
            isFill={true}
            onClick={onClick}
          />
        </ModalFooter>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  z-index: 1105 !important;
  & .modal-dialog {
    transform: none;
  }
  & .modal-content {
    padding: 24px;
    border-radius: 12px;
    box-shadow: var(--ds-bs-4);
    background: var(--ds-c-white);
    width: 343px;
    height: fit-content;
    margin-inline: auto;
    border: none;
    z-index: 1100;
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0;
  margin-bottom: 32px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 24px;
  }
`;
const CheckDoneImage = styled.img`
  display: block;
  margin-inline: auto;
  margin-bottom: 16px;
  width: 50px;
  height: 50px;
`;
const Text = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 20px;
  text-align: center;

  color: var(--ds-c-blue);
  margin: 0;
  margin-bottom: 16px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;
const SubText = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;

  color: var(--ds-c-grey-dark);
  margin: 0;

  a {
    color: var(--ds-c-blue);
    text-decoration: none;

    &:hover {
      color: var(--ds-c-blue) !important;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const ModalFooter = styled(Modal.Footer)`
  border: none;
  padding: 0;
  display: flex;
`;

export default UpdateProfilePopup;
